/** управление каналами
 */
import _ from "lodash";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages/index";
import PageTitle, { BreadCrumbs } from "components/standart/PageTitle";
import IntlMessages from "util/intlMessages";
import { path } from "./init";
import SpecialsTable from "./Table";
import Info from "./Info";
import AddSpecials from "./Add";
import AddSpecialsCompilation from "./AddCompliation";
import TestSpecialsCompilations from "./TestCompliations";
import SpecialsSettings from "./Settings";

const SpecialsCasts = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs = new BreadCrumbs() } = props;

  breadCrumbs.push({
    title: <IntlMessages id="Specials.Casts" />,
    url,
    actions: [
      // <AddSpecialsCompilation />,
      // <TestSpecialsCompilations />,
      <SpecialsSettings />,
      <AddSpecials />,
    ],
  });

  return (
    <div className="react-strap-doc">
      <Switch>
        <Route exact path={`${path}`}>
          <PageTitle {...breadCrumbs} />

          <SpecialsTable />
        </Route>

        <Route path={`${path}/special_:specialId`}>
          <Info {...{ breadCrumbs }} />
        </Route>

        <Route component={Error400} />
      </Switch>
    </div>
  );
};

export default SpecialsCasts;
